var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{staticClass:"d-flex flex-column justify-content-between",attrs:{"inlines":""}},[_c('v-col',{staticClass:"mx-auto align-center",attrs:{"cols":"12"}},[_c('v-row',{staticClass:"style-items-flex"},[_vm._t("body"),_vm._t("inline-action")],2),_c('v-row',{staticClass:"justify-content-end"},[_vm._t("action")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }